export default {
  reportGlobal: {
    cardTitle: 'Información de filtro',
    exportSuccessLabel: 'Archivo descargado exitosamente',
    loadingReportLabel: 'Cargando reporte, por favor espere...',
    exportErrorLabel: 'Error al descargar el archivo',
  },
  companySelector: {
    label: 'Empresa',
    placeholder: 'Seleccione una empresa',
  },
  monthlyActiveReport: {
    title: 'Mensuales Activos',
    cardTitle: 'Información de filtro',
    company: 'Empresa',
    subscriptionType: 'Tipo de mensualidad',
    subscriptionTypePlaceholder: 'Seleccione clase de mensual',
    validity: 'Vigencia',
    validityPlaceholder: 'Estado de la vigencia del mensual',
    nameOrId: 'Nombre o cédula mensual',
    monthlyPlate: 'Placa mensual',
    search: 'Buscar',
    clean: 'Limpiar',
    export: 'Exportar',
    tableTitle: 'Tabla de previsualización',
    tableColId: 'Documento mensual',
    tableColName: 'Nombre mensual',
    tableColPlate: 'Placa',
    tableColNumOrId: 'Número de tarjeta o id',
    tableColMontlyName: 'Servicio mensual',
    tableColslot: 'Lote',
    tableColstartDate: 'Fecha desde',
    tableColendDate: 'Fecha hasta',
    tableColsubscriptionType: 'Tipo de mensual',
    tableColvehicleType: 'Tipo de vehículo',
    tableColmonthlyStatus: 'Estado de mensual',
    slot: 'Lote',
    slotPlaceholder: 'Seleccione el lote',
  },
  collectionReport: {
   collectionDetail:'Consolidado',
   collectionDetailPlaceholder: 'Detallado',

  },
  purgeMovement: {
    errors: {
      consecutiveTooLong: 'El consecutivo no puede tener más de 20 caracteres',
    }
  }
}
